<div class="input-label" *ngIf="label">
  <label [attr.for]="_control?.id" class="iq-label">{{ label }}</label>
  <ng-content select="[label-icon]"></ng-content>
</div>
<div
  class="input-container"
  [class.has-radio-inputs]="radioInputs && radioInputs.length > 1"
>
  <span *ngIf="prefix" class="prefix">
    {{ prefix }}
  </span>
  <ng-content></ng-content>
  <i
    *ngIf="showErrorMessage && showErrorIcon"
    class="iq-icon--error iq-error-icon"
  ></i>
  <i
    *ngIf="icon"
    class="iq-icon--{{ icon }} suffix-icon"
    (click)="onIconClick()"
  ></i>
</div>
<iq-error-message
  *ngIf="errorMessage"
  errorMessage="{{ errorMessage }}"
></iq-error-message>
